/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Home from "views/enduser-home.js";
import Notifications from "views/Notifications.js";

import SelfTickets from "views/SelfTickets.js";
import UserPage from "views/UserPage.js";

var dashRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "shopping_shop",
    component: Home,
    layout: "/user",
  },
  {
    path: "/useractive",
    name: "Active Tickets",
    icon: "shopping_tag-content",
    component: SelfTickets,
    layout: "/user",
    num:5
  },



  {
    path: "/history",
    name: "History",
    icon: "files_single-copy-04",
    component: Notifications,
    layout: "/user",
  },


  {
    path: "/policy",
    name: "IT Policy",
    icon: "business_chart-pie-36",
    component: UserPage,
    layout: "/user",
  },/*
  {
    path: "/extended-tables",
    name: "Appraisal",
    icon: "sport_trophy",
    component: TableList,
    layout: "/admin",
  },
  {
    path: "/typography",
    name: "Admin Console",
    icon: "loader_gear",
    component: Typography,
    layout: "/admin",
  },*/

];
export default dashRoutes;
